class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

/*
 * Shopify Common JS
 *
 */

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	};
}

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    let option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  let method = options['method'] || 'post';
  let params = options['parameters'] || {};

  let form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(let key in params) {
    let hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    let value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    let value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    let opt       = this.countryEl.options[this.countryEl.selectedIndex];
    let raw       = opt.getAttribute('data-provinces');
    let provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (let i = 0; i < values.length; i++) {
      let opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('[type="button"]');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    if (!variantData || !Array.isArray(variantData)) {
      console.warn('🔥 | Variant data is not available or not an array');
      this.currentVariant = undefined;
      return;
    }

    if (!this.options || this.options.length === 0) {
      console.warn('🔥 | No options selected');
      this.currentVariant = undefined;
      return;
    }

    this.currentVariant = variantData.find((variant) => {
      if (!variant.options || variant.options.length !== this.options.length) {
        return false;
      }
      return variant.options.every((option, index) => {
        return this.options[index] === option;
      });
    });

    if (!this.currentVariant) {
      console.warn('🔥 | No matching variant found', {
        selectedOptions: this.options,
        availableVariants: variantData.map(v => ({ id: v.id, options: v.options }))
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant?.featured_media) return;

    const mediaId = this.currentVariant.featured_media.id;
    const sectionId = this.dataset.section;

    // Récupérer les deux mediaGallery (desktop et mobile)
    const mediaGalleryDesktop = document.querySelector(`clrz-product-media-loader #MediaGallery-${sectionId}`);
    const mediaGalleryMobile = document.querySelector(`clrz-slider-product-medias#MediaGallery-${sectionId}`);

    // Traitement de la galerie desktop
    if (mediaGalleryDesktop) {
      const mediaLoader = mediaGalleryDesktop.closest('clrz-product-media-loader');
      if (mediaLoader?.revealAll) mediaLoader.revealAll();

      const mediaList = mediaGalleryDesktop.querySelector('[data-product-media-list]');
      const newMediaItem = mediaList?.querySelector(`#Slide-${sectionId}-${mediaId}`);

      if (newMediaItem && mediaList.firstElementChild !== newMediaItem) {
        mediaList.querySelectorAll('[data-product-media-item]').forEach(item => {
          item.classList.remove('is-active');
        });
        newMediaItem.classList.add('is-active');
        mediaList.insertBefore(newMediaItem, mediaList.firstElementChild);
      }
    }

    // Traitement de la galerie mobile avec Swiper
    if (mediaGalleryMobile) {
      const sliderElement = mediaGalleryMobile.closest('clrz-slider-product-medias');
      /* Methode public existante dans le script ClrzSliderProductMedias.js */
      if (sliderElement?.slideToMediaId) {
        sliderElement.slideToMediaId(mediaId);
      }
    }

    // Mise à jour du modal
    const modal = document.getElementById(`ProductModal-${sectionId}`);
    const modalContent = modal?.querySelector('[data-product-media-modal-content]');
    const modalMediaItem = modalContent?.querySelector(`[data-media-id="${mediaId}"]`);
    
    if (modalMediaItem && modalContent.firstElementChild !== modalMediaItem) {
      modalContent.querySelectorAll('[data-media-id]').forEach(li => {
        li.classList.add('u-hidden');
      });
      modalMediaItem.classList.remove('u-hidden');
      modalContent.insertBefore(modalMediaItem, modalContent.firstElementChild);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        this.updateSourceFromDestination(html, 'price');
        this.updateSourceFromDestination(html, 'ean');
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(window.variantStrings.soldOut, !this.currentVariant.available);
      });
  }


  updateSourceFromDestination(html, id, shouldHide = (source) => false) {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const source = html.getElementById(`${id}-${sectionId}`);
    const destination = document.getElementById(`${id}-${this.dataset.section}`);
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', shouldHide(source));
    }
  };

  toggleAddButton(text, disable = true, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    // if (!button) {
    //   console.warn(`Element with ID 'product-form-${this.dataset.section}' not found.`);
    //   return;
    // }
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    // if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    // Récupère toutes les options dans l'ordre (radios et selects)
    // Ignore les "fake" variants (liens et selects avec URLs)
    const allInputs = [];
    
    // Utilise l'attribut data-variant-options pour cibler le conteneur
    const container = this.querySelector('[data-variant-options]');

    if (!container) {
      // Si le conteneur n'est pas trouvé, initialise options comme tableau vide
      console.warn('🔥 | Container [data-variant-options] not found');
      this.options = [];
      return;
    }
    
    Array.from(container.children).forEach((child, index) => {
      if (child.tagName === 'FIELDSET') {
        // Ignore les fieldsets "fake" qui contiennent des liens au lieu de radios
        // Les vrais fieldsets contiennent des input[type="radio"] avec la classe js-product-variant
        const radios = Array.from(child.querySelectorAll('input[type="radio"].js-product-variant'));
        if (radios.length === 0) {
          // C'est un fieldset "fake" avec des liens, on l'ignore
          return;
        }
        
        // Pour les vrais fieldsets, trouve le radio checked
        const checkedRadio = radios.find((radio) => radio.checked);
        if (checkedRadio) {
          allInputs.push(checkedRadio.value);
        } else {
          // Si aucun radio n'est checked, essaie de trouver le premier radio disponible
          const firstRadio = radios.find((radio) => !radio.disabled && radio.getAttribute('aria-disabled') !== 'true');
          if (firstRadio) {
            allInputs.push(firstRadio.value);
          }
        }
      } else if (child.classList.contains('product-variant-select')) {
        // Ignore les selects "fake" qui ont des URLs comme valeurs (data-product-size-select)
        const select = child.querySelector('select');
        if (!select) return;
        
        // Vérifie si c'est un select "fake" (avec data-product-size-select)
        if (select.hasAttribute('data-product-size-select')) {
          // C'est un select "fake" avec des URLs, on l'ignore
          return;
        }
        
        // Pour les vrais selects, récupère la valeur
        // Vérifie que la valeur n'est pas une URL (commence par /)
        if (select.value && !select.value.startsWith('/')) {
          allInputs.push(select.value);
        }
      }
    });
    
    this.options = allInputs;
  }
}

customElements.define('variant-radios', VariantRadios);



class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
    };

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);
